/**
 * @generated SignedSource<<bd7b8d06d7b9f5d8a1ffd6f2e0292f57>>
 * @relayHash 9986605f713d931aa38dd02c77c28489
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6ff11c087e2ea9f108d0c49fc4d8a6b2d7e53e9799f8446434ce6963ebf9fdaf

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type IssueRealtimeUpdates_issueCreatedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type IssueRealtimeUpdates_issueCreatedSubscription$data = {
  readonly jira: {
    readonly onIssueCreatedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type IssueRealtimeUpdates_issueCreatedSubscription = {
  response: IssueRealtimeUpdates_issueCreatedSubscription$data;
  variables: IssueRealtimeUpdates_issueCreatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueCreatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueCreatedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueRealtimeUpdates_issueCreatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueRealtimeUpdates_issueCreatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "6ff11c087e2ea9f108d0c49fc4d8a6b2d7e53e9799f8446434ce6963ebf9fdaf",
    "metadata": {},
    "name": "IssueRealtimeUpdates_issueCreatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "d3ea308909ff91b6b90f93ecf0f41c6e";

export default node;
